var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Diskord_icon",
    "data-name": "Diskord icon",
    transform: "translate(-28 -175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 30,
    height: 30,
    rx: 13,
    transform: "translate(28 205) rotate(-90)",
    fill: "#1e2033",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "download_2_",
    "data-name": "download (2)",
    d: "M41.9,33.206a.048.048,0,0,0-.024-.022A15.468,15.468,0,0,0,38.057,32a.058.058,0,0,0-.061.029,10.759,10.759,0,0,0-.475.976,14.281,14.281,0,0,0-4.287,0,9.868,9.868,0,0,0-.483-.976A.06.06,0,0,0,32.689,32a15.424,15.424,0,0,0-3.817,1.183.055.055,0,0,0-.025.022,15.813,15.813,0,0,0-2.77,10.668.064.064,0,0,0,.024.044,15.551,15.551,0,0,0,4.682,2.366.061.061,0,0,0,.066-.022,11.1,11.1,0,0,0,.958-1.557.059.059,0,0,0-.033-.083,10.242,10.242,0,0,1-1.463-.7.06.06,0,0,1-.006-.1c.1-.074.2-.15.29-.228a.058.058,0,0,1,.061-.008,11.092,11.092,0,0,0,9.423,0,.058.058,0,0,1,.061.007c.094.077.192.155.291.228a.06.06,0,0,1-.005.1,9.61,9.61,0,0,1-1.463.7.06.06,0,0,0-.032.083,12.469,12.469,0,0,0,.957,1.557.059.059,0,0,0,.066.022,15.5,15.5,0,0,0,4.69-2.366.06.06,0,0,0,.024-.043A15.709,15.709,0,0,0,41.9,33.206Zm-9.632,8.538a1.9,1.9,0,0,1,0-3.778,1.9,1.9,0,0,1,0,3.778Zm6.23,0a1.9,1.9,0,0,1,0-3.778,1.9,1.9,0,0,1,0,3.778Z",
    transform: "translate(7.625 150.858)",
    fill: "#ebecff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.1b741165.svg";
export { ForwardRef as ReactComponent };